import * as z from "zod/v4";

export const getBigcommerceOrderCounts = {
  name: "getBigcommerceOrderCounts" as const,
  input: z.object({
    teamId: z.string(),
    startYear: z.number(),
    startMonth: z.number(),
    endYear: z.number(),
    endMonth: z.number(),
  }),
  output: z.object({
    months: z.array(
      z.object({
        year: z.number(),
        month: z.number(),
        label: z.string(),
        count: z.number(),
      }),
    ),
    error: z.string().nullish(),
  }),
};
